export default "__VITE_ASSET__BaQvAZxR__"